<template>
  <div>
    <p id="dashboardItemTitle">Template List</p>
    <div style="margin-top: 30px">

      <section v-if="!isLoading">

        <div class="columns">
          <div class="column is-3">
            <b-field>
              <b-select placeholder="Select a Status" expanded
                        v-model="formdata.TemplateStatus"  @input="filterTable()">
                <option
                    v-for="option in TemplateStatus "
                    :value="option.id"
                    :key="option.id">
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>

          <div class="column is-3">
            <b-field>
              <b-select placeholder="Select a Template Category" expanded
                        v-model="formdata.TemplateCategory" @input="filterTable()">
                <option
                    v-for="option in templateCategories "
                    :value="option.name"
                    :key="option.id">
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>

          <div class="column is-3">
            <b-field>
              <b-select placeholder="Select a Language" expanded
                        v-model="formdata.Language"  @input="filterTable()">
                <option
                    v-for="option in Language "
                    :value="option.name"
                    :key="option.id">
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>

          <div class="column is-2">
            <b-field>
              <b-button class="is-dark" icon-left="filter-off" @click="clearFilter()">Clear Filter</b-button>
            </b-field>
          </div>
        </div>

        <div class="columns">
          <div class="column is-3 ">
            <b-field>
              <b-input placeholder="Search data" v-model="searchKeyword" type="search" icon="magnify"></b-input>
            </b-field>
          </div>
        </div>

        <template v-if="tableRows.length < 1" >
          <div class="empty-indicator">
            <span class="icon has-text-grey-lighter is-normal">
                <i class="mdi mdi-information-outline mdi-24px"></i>
            </span>
            <span class="ml-2 has-text-grey-lighter">No records to display</span>
          </div>
        </template>

        <b-table
            v-else
            :data="filterTableData(tableRows,searchableFields,searchKeyword)"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :hoverable="isHoverable"
            :bordered="isBordered"
            :striped="isStriped"
            :narrowed="isNarrowed"
            :sticky-header="stickyHeaders"

            pagination-size="is-small"
            default-sort="reference_id"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">


          <b-table-column field="template_name" label="Template Name" width="120" sortable v-slot="props" centered>
            {{ props.row.template_name }}
          </b-table-column>

          <b-table-column field="template_category" label="Template Category" sortable v-slot="props" centered>
            {{ props.row.template_category }}
          </b-table-column>

          <b-table-column field="department" label="Department" sortable v-slot="props" centered>
            {{ props.row.department }}
          </b-table-column>

          <b-table-column field="created_by" label="Created By" sortable v-slot="props" centered>
            {{ props.row.created_by }}
          </b-table-column>

          <b-table-column field="status" label="Status" sortable v-slot="props" centered>
            <b-tag class="is-success" v-if="props.row.is_complete == 1" >Complete</b-tag>
            <b-tag class="is-danger" v-else>Incomplete</b-tag>
          </b-table-column>

          <b-table-column field="created_at" label="Timestamp" sortable v-slot="props" centered>
            {{ DateFormat(props.row.created_at) }}
          </b-table-column>

          <b-table-column field="document_action" label="Action" v-slot="props" centered>
            <b-button size="is-small" type="is-info" icon-left="eye"
                      @click="$router.push( {name:'templateView',params:{id:props.row.id}})">View
            </b-button>
          </b-table-column>

        </b-table>

      </section>

      <section v-else>
        <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="true"></b-loading>
      </section>

    </div>

  </div>
</template>
<script>
// import axios from "axios";

import axios from "axios";


export default {

  name:'template-internalstaff-list',

  components:{

  },

  data(){
    return {
      tableRows:[], // to store pending documents
      isLoading:false,

      showTemplateDeleteModal:false,

      searchableFields:['template_name','template_category','department','created_by','created_at'],
      searchKeyword: "",

      templateCategories:[],
      Language:[
        {id:1,name:'Sinhala'},
        {id:2,name:'Tamil'},
        {id:3,name:'English'},
      ],

      TemplateStatus:[
        {id:1,name:'complete'},
        {id:0,name:'incomplete'}
      ],

      isPaginated: true,
      isHoverable: true,
      isBordered: false,
      isStriped: true,
      isNarrowed: false,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      currentPage: 1,
      perPage: 10,
      stickyHeaders: true,

      template_id:'',

      formdata:{
        TemplateStatus:null,
        TemplateCategory:null,
        Language:null
      },

      columns: [

        {
          field: 'created_by',
          label: 'Created By',
          width: '200',
          centered:true,

        },
        {
          field: 'title',
          label: 'Title',
          centered:true,
        },
        {
          field: 'status',
          label: 'Status',
          centered:true,
        },
        {
          field: 'recipient',
          label: 'Recipient',
          centered:true,
        }
      ]
    }
  },

  methods: {

    DateFormat:function(date)
    {
      //date formatting
      var d = new Date(date)
      var datestring = d.getFullYear() + "-"+ (d.getMonth()+1) + "-"+ d.getDate();

      console.log(datestring);

      //hours formatting
      var hours = d.getHours();
      var minutes = d.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;

      var dateTime = datestring +' : '+ strTime
      return dateTime

      // console.log('dateformat js'+datestring);
    },

    filterTableData:function (sourceData, fields, keyword){

      var outputArray = [];
      sourceData.forEach(function(row){
        let pushed = false
        fields.forEach(function(fieldName){
          if(String(row[fieldName]).match(RegExp(keyword, "i")) && !pushed){
            outputArray.push(row)
            pushed = true
          }
        });
      });

      return outputArray
    },

    clearFilter:function (){
      this.formdata.TemplateCategory = null
      this.formdata.Language = null
      this.formdata.TemplateStatus = null
      this.getTemplateList()
    },

    filterTable:function (){

      var comp = this
      let formData = new FormData()
      formData.append('user_id',comp.$root.user_id)
      formData.append('template_category',comp.formdata.TemplateCategory)
      formData.append('template_status',comp.formdata.TemplateStatus)
      formData.append('language',comp.formdata.Language)

      axios.post(comp.$base_url+'/agent/filterData', formData)
          .then(function (response) {
            console.log(response.data)
            comp.tableRows = response.data
          })
          .catch(function (error) {
            console.log(error)


            comp.$buefy.toast.open({
              message: "Failed to get filter data",
              type: "is-danger",
            });
          });

    },

    //department & category
    getDataList:function (){
      const comp = this
      try {

        axios.post(comp.$base_url+'/agent/getDataListforDropdown', {
          auth_token:comp.$root.agentAuthToken,
          user_id:comp.$root.user_id
        })
            .then(function (response) {
              // console.log(response)
              comp.templateCategories = response.data.categoryList
            })
            .catch(function (error) {
              console.log(error)

              comp.$buefy.toast.open({
                message: "Failed to get template categories",
                type: "is-danger",
              });
            });

      }
      catch (e) {
        comp.$buefy.toast.open({
          message: "Failed to get departments",
          type: "is-danger",
        });
        console.log("Exception occurred in getDepartmentList() : "+e.message)
      }
    },


    cancelDeleteModal:function (){
      this.showTemplateDeleteModal = false
      this.template_id = ''
    },

    //check authentication
    validateToken:function (){
      var component = this

      axios.post(component.$base_url+'/agent/checkAuthentication', {
        auth_token:component.$root.agentAuthToken
      })
          .then(function (data) {
            var array =[]
            array = data.data


            console.log(array.data.message)
            if(array.success == true){
              console.log(array.data.message)
              //load department & template ctg
              component.getDataList()

            }else{
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }

          })
          .catch(function (error) {
            var array =[]
            array = error.response
            //session expired
            console.log(array.data.success)
            if(array.data.success == false){
              component.$buefy.toast.open({
                message: 'Authentication failed',
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }
          });

    },

    getTemplateList: function () {
      var comp = this

      try {
        axios.post(comp.$base_url + '/agent/getTemplateListforInternalStaffMembers', {
          user_id: comp.$root.user_id,
          auth_token:comp.$root.agentAuthToken
        })
            .then(function (response) {
                comp.template_id = ''
                comp.showTemplateDeleteModal = false
                console.log("get template list---------------")
                console.log(response)
                comp.tableRows = response.data.data
                comp.isLoading = false

            })
            .catch(function (error) {
              console.log(error)

              comp.$buefy.toast.open({
                message: "Failed to fetch data",
                type: "is-danger",
              });
            });

      } catch (e) {
        comp.$buefy.toast.open({
          message: e,
          type: "is-danger",
        });
        console.log("Exception occurred in Customer Template List getTemplateList() : " + e.message)
      }
    },

  },

  mounted() {
    this.validateToken()
    this.getTemplateList()
    this.getDataList()
  },

}

</script>
<style scoped>
#dashboardItemTitle{
  color: #A5A6B3;
  font-weight: 600;
  font-size: 30px;
  text-align: left
}
</style>
